import { cmsInstance } from '../base';

import { normalizeUserManual } from './normalizers';
import { IUserManual } from './types';

const cmsAPI = {
  async getUserManual(): Promise<IUserManual> {
    const result = await cmsInstance.get(`sections`);

    return normalizeUserManual(result.data);
  },
};

export default cmsAPI;
